import React from 'react';

/**
 * Pinar English Academy logo - clean SVG rebuild
 * Circular Union Jack background with a green pine tree overlaid in the center.
 */
const PinarLogo = ({ size = 48, className = '' }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      aria-label="Pinar English Academy"
      role="img"
    >
      <defs>
        <clipPath id="pinar-circle-clip">
          <circle cx="50" cy="50" r="46" />
        </clipPath>
        <filter id="pinar-tree-shadow" x="-10%" y="-10%" width="120%" height="120%">
          <feDropShadow dx="0" dy="0.4" stdDeviation="0.6" floodColor="#0A2610" floodOpacity="0.6" />
        </filter>
      </defs>

      {/* Outer thin gold ring */}
      <circle cx="50" cy="50" r="48.5" fill="none" stroke="#B08D3C" strokeWidth="1.2" />

      {/* Union Jack inside circle */}
      <g clipPath="url(#pinar-circle-clip)">
        {/* Blue field */}
        <rect x="0" y="0" width="100" height="100" fill="#1E3A5F" />

        {/* White diagonal saltires */}
        <line x1="0" y1="0" x2="100" y2="100" stroke="#FAF6EC" strokeWidth="16" />
        <line x1="100" y1="0" x2="0" y2="100" stroke="#FAF6EC" strokeWidth="16" />

        {/* Red diagonals (thinner) */}
        <line x1="0" y1="0" x2="100" y2="100" stroke="#9B2C3B" strokeWidth="6" />
        <line x1="100" y1="0" x2="0" y2="100" stroke="#9B2C3B" strokeWidth="6" />

        {/* White cross */}
        <rect x="0" y="41" width="100" height="18" fill="#FAF6EC" />
        <rect x="41" y="0" width="18" height="100" fill="#FAF6EC" />

        {/* Red cross (thinner) */}
        <rect x="0" y="45" width="100" height="10" fill="#9B2C3B" />
        <rect x="45" y="0" width="10" height="100" fill="#9B2C3B" />
      </g>

      {/* Inner subtle gold ring */}
      <circle cx="50" cy="50" r="46" fill="none" stroke="#B08D3C" strokeWidth="0.9" opacity="0.9" />

      {/* Pine tree centered, larger and clearly visible */}
      <g transform="translate(50, 52)" filter="url(#pinar-tree-shadow)">
        {/* Trunk */}
        <rect x="-3.2" y="24" width="6.4" height="14" fill="#3A2818" rx="0.6" />
        {/* Foliage - 4 tiers, tall pine silhouette */}
        <path
          d="M0,-42
             L-11,-24
             L-6,-24
             L-16,-11
             L-9,-11
             L-20,3
             L-11,3
             L-24,18
             L-14,18
             L-28,30
             L28,30
             L14,18
             L24,18
             L11,3
             L20,3
             L9,-11
             L16,-11
             L6,-24
             L11,-24 Z"
          fill="#1F6B2F"
          stroke="#0F3F1B"
          strokeWidth="0.9"
          strokeLinejoin="round"
        />
        {/* Central highlight line for depth */}
        <path
          d="M0,-42 L0,30"
          stroke="#0F3F1B"
          strokeWidth="0.5"
          opacity="0.55"
        />
      </g>
    </svg>
  );
};

export default PinarLogo;
